import React, { Component } from 'react';
import {ProductConsumer} from '../context';
import {Link} from 'react-router-dom';
import {MDBNavLink} from 'mdbreact';
import './details.css';

class details extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <ProductConsumer>
            {value =>{
                const {id, make, image, title, disc, price} = 
                value.detailProduct;
                return (
                    <div className="container">
                        <div className="d-flex flex-row">
                            <MDBNavLink to="../" className="p-0 m-0"><i class=" my-5 pt-2 pr-3 fas fa-arrow-left"></i></MDBNavLink>
                            <h1 className="field my-5">Details</h1>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <img src={image} alt="" className="img-fluid mb-5"/>
                            </div>
                            <div className="col-sm-12 col-lg-6 title my-3">
                                <h5>Brand: {make}</h5>
                                <h1 className="detail-title">{title}</h1>
                                <p className="disc my-3">{disc}</p>
                                <div className="bottom d-flex flex-row align-items-center">
                                    <h3 className="detail-price m-0">Price: ${price}.00</h3>
                                    <i className="mx-2 fas fa-shopping-cart"
                                    onClick={()=>{
                                    value.addToCart(id);
                                    }}/>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }}
            </ProductConsumer>
        );
    }
}

export default details;

